const Legend = () => {
  const legendStyle = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
  };

  const squareStyle = {
    width: '20px',
    height: '20px',
    marginRight: '5px',
    border: '1px solid #000',
  };

  return (
    <div style={legendStyle}>
      <div style={{ ...squareStyle, backgroundColor: '#ffffff' }}></div>
      {'Staging'} &nbsp;
      <div style={{ ...squareStyle, backgroundColor: '#FFE985' }}></div>
      {'Source'} &nbsp;
      <div style={{ ...squareStyle, backgroundColor: '#79B983' }}></div>
      {'Published'}
    </div>
  );
};

export default Legend;
